import Button from '@mui/material/Button';
import { PromptMenuItem, PromptTextarea, ButtonGroup } from './styles';
import type { KeyboardShortcut } from 'components/editor/hooks/useKeyboardShortcuts';
import { useKeyboardShortcuts } from 'components/editor/hooks/useKeyboardShortcuts';

type PromptDialogProps = {
  prompt: string;
  onPromptChange: (value: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
  placeholder: string;
  cancelLabel: string;
  submitLabel: string;
};

export const PromptDialog = ({ prompt, onPromptChange, onCancel, onSubmit, placeholder, cancelLabel, submitLabel }: PromptDialogProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key !== 'Enter' || e.shiftKey) {
      e.stopPropagation();
    }
  };

  const keyboardShortcuts: KeyboardShortcut[] = [
    {
      key: 'Enter',
      callback: () => {
        if (prompt.trim()) {
          onSubmit();
        }
      },
      isEnable: true,
      shift: false,
      allowInInput: true,
    },
  ];

  useKeyboardShortcuts(keyboardShortcuts);

  return (
    <PromptMenuItem>
      <PromptTextarea
        variant="outlined"
        autoFocus
        multiline
        rows={3}
        fullWidth
        sx={{
          '& .MuiInputBase-root': {
            padding: '6px',
          },
        }}
        placeholder={placeholder}
        value={prompt}
        onChange={(e) => onPromptChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <ButtonGroup>
        <Button onClick={onCancel}>{cancelLabel}</Button>
        <Button onClick={onSubmit} variant="contained" disabled={!prompt.trim()}>
          {submitLabel}
        </Button>
      </ButtonGroup>
    </PromptMenuItem>
  );
};
